import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AppInitService } from 'src/app/shared/modules/core/services/app-initializer.service';
import { CurrentFacilityService, InitialConfigurationService } from 'src/app/shared/services';
import { BannersService } from 'src/app/shared/services/banners.service';
import { FacilityConfigurationService } from 'src/app/shared/services/facility-configuration.service';
import { portalsMaintenance } from 'src/app/shared/utils/notifications';
import { BdpFacilityConfig } from './config/facility-config';
@Component({
    selector: 'app-root',
    templateUrl: './bdp.component.html',
    styleUrls: ['./bdp.component.scss'],
    standalone: false,
})
export class BdpComponent implements OnInit, OnDestroy {
    private readonly appFavicon = this.document.getElementById('appFavicon');
    private unsubscribe$: Subject<void> = new Subject<void>();
    public isLoading$: Observable<boolean>;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private titleService: Title,
        private currentFacilityService: CurrentFacilityService,
        private sanitizer: DomSanitizer,
        private initialConfigurationService: InitialConfigurationService,
        private appInitService: AppInitService,
        private facilityConfigurationService: FacilityConfigurationService,
        private readonly bdpFacilityConfig: BdpFacilityConfig,
        private readonly bannersService: BannersService
    ) {
        this.isLoading$ = this.appInitService.isLoading$;
    }

    ngOnInit(): void {
        this.setFacilityConfiguration();
        this.subscribeInitialConfiguration();
        this.currentFacilityService.setFacilitySource('bdp');
        this.currentFacilityService.setInitialConfiguration({
            indexTitle: 'BDP Aviation Services',
            urlFavIcon: 'assets/bdp/img/bdp-favicon.webp',
            mainLogoLightUrl: 'bdp/img/bdp-logo-light.svg',
            mainLogoDarkUrl: 'bdp/img/bdp-logo-dark.svg',
            urlAdministrative: '',
            name: 'BDP Aviation Services',
            email: 'support@cargosprint.com',
            termsOfUseURL: 'https://cargosprint.com/legal/terms-of-use/#sprintpay',
            privacyAndPolicyURL: 'https://cargosprint.com/legal/privacy-policy',
        });
        this.setFavicon();
        this.setTitle();
        this.displayMaintenanceBanner();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    setFavicon(): void {
        const favIcon = this.sanitizer.sanitize(SecurityContext.URL, this.currentFacilityService.getUrlFavIcon()) || '';

        this.renderer.setAttribute(this.appFavicon, 'href', favIcon);
    }

    setTitle(): void {
        const title = this.currentFacilityService.getIndexTitle();
        this.titleService.setTitle(title);
    }

    subscribeInitialConfiguration(): void {
        this.initialConfigurationService.setInitialConfiguration().pipe(takeUntil(this.unsubscribe$)).subscribe();
    }

    setFacilityConfiguration(): void {
        this.facilityConfigurationService.setFacilityConfiguration(this.bdpFacilityConfig.getConfigDynamicField());
    }

    private displayMaintenanceBanner(): void {
        this.bannersService.setBanners([portalsMaintenance]);
    }
}
